export function debounceAsync(
  func: (input: string, ...rest: any) => Promise<any>,
  delay: number,
  minSearchLength = 3,
  allowEmpty = false,
): (input: string, ...rest: any) => Promise<any> {
  let timer: NodeJS.Timeout | null = null;
  let pendingPromise: Promise<any> | null = null;

  return (input: string, ...rest: any) => {
    if (timer) {
      clearTimeout(timer);
    }

    pendingPromise = new Promise((resolve, reject) => {
      timer = setTimeout(async () => {
        try {
          const isEmpty = !input || input === '';
          // When allowEmpty is set, an empty input is allowed through (the caller fires a
          // browse search with no query param). A non-empty input still needs minSearchLength.
          if (isEmpty ? !allowEmpty : input.length < minSearchLength) {
            resolve([]);
            return;
          }
          const result = await func(input, ...rest);
          resolve(result);
        } catch (error) {
          reject(error);
        } finally {
          timer = null;
        }
      }, delay);
    });

    return pendingPromise;
  };
}
